import React from "react";
import { Box, Chip } from "@mui/material";

const TagChips = ({ selectedTags, onDeleteTag }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        marginX: 2,
        ...(selectedTags.length > 0 && { mb: 2 }),
      }}
    >
      <Box
        sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
      >
        {selectedTags.map((tag, index) => (
          <Chip
            key={index}
            label={
              typeof tag === "object" && tag !== null ? tag.name || "" : tag
            }
            onDelete={() => onDeleteTag(tag)}
            sx={{ backgroundColor: "#f39c12", color: "white" }}
            size="small"
          />
        ))}
      </Box>
    </Box>
  );
};

export default TagChips;
